import { connect } from 'react-redux';
import { Users } from './Users';
import { getCurrentUser, getDisplayedColumns, getFilters, getImportUsersLoading, getImportUsersResults, getUsersCollection, getUsersCollectionLoading, } from 'src/redux/users/usersSelectors';
import { usersActions } from 'src/redux/users/usersActions';
import { getI18n } from 'src/redux/core/coreSelectors';
import { getGroups, getUsersImportPermission } from 'src/redux/auth/authSelectors';
var mapStateToProps = function (state) { return ({
    i18n: getI18n(state),
    users: getUsersCollection(state),
    groups: getGroups(state),
    filters: getFilters(state),
    columns: getDisplayedColumns(state),
    currentUser: getCurrentUser(state),
    isUsersLoading: getUsersCollectionLoading(state),
    isImportLoading: getImportUsersLoading(state),
    usersImportResult: getImportUsersResults(state),
    isUsersImportDisplayed: getUsersImportPermission(state)
}); };
var mapDispatchToProps = function (dispatch) { return ({
    fetchUsersRequested: function () { return dispatch(usersActions.fetchUsersRequested()); },
    updateFilters: function (newFilters) { return dispatch(usersActions.updateUsersFilterRequested(newFilters)); },
    exportUsersInCSV: function () { return dispatch(usersActions.exportUsersInCSVRequested()); },
    fetchCurrentUserDetailsRequested: function (userId) { return dispatch(usersActions.fetchCurrentUserDetailsRequested(userId)); },
    clearCurrentUser: function () { return dispatch(usersActions.clearCurrentUser()); },
    updateUserRequested: function (user) { return dispatch(usersActions.updateUserRequested(user)); },
    deleteUserRequested: function (user) { return dispatch(usersActions.deleteUserRequested(user)); },
    importUsersInCSVRequested: function (file) { return dispatch(usersActions.importUsersInCSVRequested(file)); },
    clearUsersImport: function () { return dispatch(usersActions.clearUsersImport()); },
}); };
export default connect(mapStateToProps, mapDispatchToProps)(Users);
